import _ from 'lodash';
import { createSelector } from 'reselect';
import * as ROUTE_CONSTANTS from 'app/route-constants';

// TODO STORE-2701: 404 will never display 'Marketing Nav' because a route
//      with the status '404' will not be found in route-constants.js
const getConstants = (state, route) =>
  _(ROUTE_CONSTANTS)
    .filter(config =>
      _.get(route, 'path').indexOf(config.BASE_URI) === 0)
    // find deepest matching constant (take /thing/child not /thing)
    // case of '/' is special
    .maxBy(config => (config.BASE_URI === '/'
      ? 1
      : config.BASE_URI.split('/').length))
      || {
        HIDE_NAV_LINKS: false,
        HIDE_USER_SECTION: false,
        USE_MARKETING_NAV: true,
        INCLUDE_BUY_BUTTON: true,
        SHOW_GLOBAL_FOOTER: true,
      };


const getRouteConstants = createSelector(
  getConstants,
  constants => constants,
);

export default getRouteConstants;



// WEBPACK FOOTER //
// ./app/selectors/route.js